import React from "react"

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { Toaster } from 'react-hot-toast'
//import "./assets/css/app.css"

import AuthLayout from './components/layout/auth/authLayout'

import Page404 from "./components/404"

import Main from './components/layout/dashboard/main'
import Logout from './components/auth/logout'

import ForgetPasswordVerify from "./components/auth/forgetPasswordVerify"

import { PrivateRoute } from './routes/PrivateRoutes'

function App() {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<AuthLayout/>} />
          <Route path='/404' element={<Navigate to="/404" />}/>
          <Route exact path="/auth/*" element={<AuthLayout/>} />
          <Route exact path='/auth/logout' element={<Logout/>}/>
          <Route exact path='/forgetPasswordVerify/:code' element={<ForgetPasswordVerify/>}/>
          <Route element={< PrivateRoute/> }>
            <Route exact path='/dashboard/*' element={<Main/>}/>
          </Route>
          <Route path='*' element={<Navigate to="/404" />}/>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App